import { Fragment, useEffect } from 'react';
import { Outlet, useSearchParams } from 'react-router-dom';
import Form from '@features/form/Form';
import Tab from '@features/tab/Tab';
import { dynamicImportL10N, setServiceAlias, selectKeyword, selectAlias } from '@features/ui/UiSlice';
import { ALIAS, SEARCH_PARAMS, SERVICE_ALIAS } from '@constants/index';
import { useAppDispatch, useAppSelector } from '@hooks/defineRtkTypedHook';
import { useOption } from '@hooks/useOption';
import usePrevious from '@hooks/usePrevious';
import type { l10nType } from '@type/index';

export const AppLoader = (dispatch) => async (): Promise<l10nType> => {
  const { payload } = await dispatch(dynamicImportL10N());

  return payload;
};

const App = () => {
  const { serviceAlias } = useOption();
  const [searchParams, setSearchParams] = useSearchParams();
  const alias = useAppSelector(selectAlias);
  const keyword = useAppSelector(selectKeyword);
  const prevKeyword = usePrevious(keyword);
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setServiceAlias(serviceAlias));
  }, []);

  // keyword 변경 (초기 로드 시 키워드 없는 상태에선 실행되지 않도록)
  useEffect(() => {
    if (serviceAlias === SERVICE_ALIAS.AION && alias === ALIAS.CHARACTER) {
      return;
    }

    if (prevKeyword !== undefined && keyword && prevKeyword !== keyword) {
      searchParams?.set(SEARCH_PARAMS.KEYWORD, keyword);
      searchParams?.set(SEARCH_PARAMS.PAGE, '1');
      setSearchParams(searchParams);
    }
  }, [keyword]);

  return (
    <Fragment>
      <Form />
      <Tab />
      <Outlet />
    </Fragment>
  );
};

export default App;
